import parentLogger from '@utils/logger'
import { NEXT_PUBLIC_DOMAIN_NAME } from '@utils/client-side-config'
import { IBreadcrumbLink, IBreadcrumbStructuredData } from 'types/breadcrumbs'
import * as Sentry from '@sentry/nextjs'

const moduleLogger = parentLogger.child('utils/breadcrumbs')
const platformDomain = NEXT_PUBLIC_DOMAIN_NAME || 'noissue.co'

const pathToUrl = (path) => {
  const origin = `https://${platformDomain}/`

  if (!path) {
    return origin
  }

  try {
    return new URL(path, origin)?.href || ''
  } catch (err) {
    moduleLogger.error(`Failed to generate URL for ${path}. Returning origin.`)

    Sentry.captureMessage(`Failed to generate breadcrumb link for the path`, {
      level: 'warning',
      contexts: {
        breadcrumbs: {
          path,
          origin,
        },
      },
    })

    return origin
  }
}

const getPageBreadcrumbs = (
  breadcrumbPages: {
    name: string
    path: string
  }[]
): IBreadcrumbLink[] => {
  const baseBreadcrumbs: IBreadcrumbLink[] = [
    {
      name: 'Home',
      url: pathToUrl('/'),
    },
  ]

  const pageSpecificBreadcrumbs: IBreadcrumbLink[] =
    breadcrumbPages.map((page) => {
      return {
        name: page.name,
        url: pathToUrl(page.path),
      }
    }) || []

  return [...baseBreadcrumbs, ...pageSpecificBreadcrumbs]
}

const breadcrumbsLinksToStructuredData = (
  breadcrumbLinks: IBreadcrumbLink[]
): IBreadcrumbStructuredData[] => {
  if (!breadcrumbLinks?.length) {
    return []
  }

  return breadcrumbLinks?.map((link, index) => {
    return {
      position: index + 1,
      name: link.name,
      item: link.url,
    }
  })
}

export { breadcrumbsLinksToStructuredData, getPageBreadcrumbs, pathToUrl }
